/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UtilHttpRowIdBody model module.
 * @module model/UtilHttpRowIdBody
 * @version 1.0
 */
class UtilHttpRowIdBody {
    /**
     * Constructs a new <code>UtilHttpRowIdBody</code>.
     * @alias module:model/UtilHttpRowIdBody
     */
    constructor() { 
        
        UtilHttpRowIdBody.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UtilHttpRowIdBody</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UtilHttpRowIdBody} obj Optional instance to populate.
     * @return {module:model/UtilHttpRowIdBody} The populated <code>UtilHttpRowIdBody</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UtilHttpRowIdBody();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
UtilHttpRowIdBody.prototype['id'] = undefined;






export default UtilHttpRowIdBody;

